import React from "react";
import { Button, Empty, Space, theme, Typography } from "antd";

const { Text, Title } = Typography;

interface EmptyStateAction {
  label: string;
  onClick: () => void;
  type?: "primary" | "default";
  icon?: React.ReactNode;
}

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  primaryAction?: EmptyStateAction;
  secondaryAction?: EmptyStateAction;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No data",
  description,
  icon,
  primaryAction,
  secondaryAction,
}) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        gap: 8,
      }}
    >
      {icon ? (
        <div style={{ fontSize: 40, color: token.colorTextQuaternary, marginBottom: 4 }}>{icon}</div>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} style={{ marginBottom: 4 }} />
      )}

      <Title level={5} style={{ margin: 0, color: token.colorText, fontWeight: 600 }}>
        {title}
      </Title>

      {description && (
        <Text style={{ fontSize: 13, color: token.colorTextSecondary, textAlign: "center", maxWidth: 380 }}>
          {description}
        </Text>
      )}

      {(primaryAction || secondaryAction) && (
        <Space style={{ marginTop: 8 }}>
          {secondaryAction && (
            <Button
              type={secondaryAction.type ?? "default"}
              icon={secondaryAction.icon}
              onClick={secondaryAction.onClick}
            >
              {secondaryAction.label}
            </Button>
          )}
          {primaryAction && (
            <Button
              type={primaryAction.type ?? "primary"}
              icon={primaryAction.icon}
              onClick={primaryAction.onClick}
            >
              {primaryAction.label}
            </Button>
          )}
        </Space>
      )}
    </div>
  );
};

export default EmptyState;
